import React, { useState, useEffect, useRef } from "react";

import { containerStyle, hiddenTextStyle } from "./styled";

const AnimatedText = () => {
  const texts = ["Depositando", "Transfiriendo", "Jugando"];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const containerRef = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible(false);

      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % texts.length);
        setIsVisible(true);
      }, 300);
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  const longestText = texts.reduce((a, b) => (a.length > b.length ? a : b));

  const visibleTextStyle = {
    position: "absolute",
    top: "0.2rem",
    left: "0.6rem",
    right: "0.6rem",
    transition: "all 0.3s ease-in-out",
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "translateY(0)" : "translateY(-5px)",
  };

  return (
    <span style={containerStyle} ref={containerRef}>
      <span style={hiddenTextStyle}>{longestText}</span>
      <span style={visibleTextStyle}>{texts[currentIndex]}</span>
    </span>
  );
};

export default AnimatedText;
